<template>
    <div>
        <div>

            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <v-card flat>

                    <v-card-title>
                        {{input.name}}
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="3"
                                >
                                    <v-text-field
                                        :label=$page.language.user.name
                                        :placeholder=$page.language.user.name
                                        v-model="user.name"

                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="3"
                                >
                                    <v-text-field
                                        :label=$page.language.user.email
                                        placeholder=$page.language.user.email
                                        v-model="user.email"

                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="3"
                                >
                                    <v-select
                                        v-model="user.locale"
                                        :items="languages"
                                        item-text="name"
                                        item-value="short"
                                        :label=$page.language.user.language
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="6"
                                    md="3"
                                >
                                    <v-select
                                        v-model="user.role"
                                        :items="roles"
                                        :label=$page.language.user.role
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn @click="update" style="margin-right: 8px;">
                                        {{ $page.language.user.update_user }}
                                    </v-btn>
                                    <v-btn @click="$inertia.visit(route('users.index'), { preserveScroll: true })">
                                        {{ $page.language.user.back_to_list }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                </v-card>
            </div>
        </div>

    </div>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'

    export default {
        name: "UsersShow",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            }
        },

        components: {
        },
        data() {
            return {
                title: 'User Details',
                user: this.input || {},
                languages: [{"name":"English","short":"en"},{"name":"French","short":"fr"}],
                roles: ["Admin","Staff"],
            }
        },
        methods: {
            update() {
                self = this
                axios.put('/users/' + this.user.id, {
                    id: this.user.id,
                    name: this.user.name,
                    email: this.user.email,
                    locale: this.user.locale,
                    role: this.user.role
                })
                    .then(function (response) {
                        self.$root.is_dirty = false
                        self.$root.snackbar.success('User has been updated')
                        console.log(response);
                    })
                    .catch(function (error) {
                        self.$root.snackbar.error('Could not update user: ' + error.response.data.message)
                        console.log(error);
                    });
            },
            test() {
                console.log(this.$root.$refs)
            }
        },
        watch: {
            user: {  // Watch for data changes on the page
                handler(newVal, oldVal) {
                    this.$root.is_dirty = true
                },
                deep: true,
                immediate: false,
            },
        },

    }
</script>
